import { useCallback, useState } from 'react';
import { getMaxZIndex } from 'utils/DomUtils';

export function useMaxZIndex() {
  const [zIndex, setZIndex] = useState(getMaxZIndex());

  const refresh = useCallback(() => {
    setZIndex(getMaxZIndex());
  }, []);

  return { zIndex, refresh };
}
